import React, { Component } from 'react';
import styles from './accordion.module.scss';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Collapse } from 'react-collapse';
import AccordionContent from './accordion-content';
import PropTypes from 'prop-types';
import scrollTo from '../../modules/scroll-to';
import safeGa from '../../modules/safeGa';

const TIME_TO_RESIZE = 500;

class Accordion extends Component {
  constructor() {
    super();
    this.state = {
      itemInitialPositions: {},
      lastOpenedItem: null,
      isFirstLoad: true,
    };
    this.continuouslyScrollToPosition = this.continuouslyScrollToPosition.bind(
      this
    );
  }

  componentDidMount() {
    // Lets find the on load positions for each accordion item and store them in state.
    // We keep a flag for our first render, to keep everything closed, so we can get proper positions.
    const { items, activeId } = this.props;
    this.elementInitialPositions = {};
    items.forEach(item => {
      this.elementInitialPositions[item.id] = this[item.id].offsetTop;
    });

    // Focus if we're active
    if (activeId) {
      this[activeId].querySelector('a').focus();
    }

    this.setState({
      isFirstLoad: false,
    });
    this.scrollToActive();
  }

  scrollToActive(id) {
    let idToUse = id || this.props.activeId;
    if (idToUse === this.state.lastOpenedItem) {
      // We're closing
      this.setState({
        lastOpenedItem: null,
      });
      return;
    }
    if (!idToUse) return;

    // Start a callback that will continuously scroll to this position.
    this.scrollTo = this.elementInitialPositions[idToUse] || 0;
    this.continuouslyScrollToPosition();

    // After a fraction of a second stop the continuous scroll
    setTimeout(() => {
      cancelAnimationFrame(this.animationFrame);
      this.scrollTo = null;
    }, TIME_TO_RESIZE);

    // Finally store that we've just scrolled to this item.
    this.setState({
      lastOpenedItem: idToUse,
    });
  }

  continuouslyScrollToPosition() {
    scrollTo(0, this.scrollTo);
    this.animationFrame = window.requestAnimationFrame(
      this.continuouslyScrollToPosition
    );
  }

  renderHeadlineContainer(d) {
    const isActiveItem = d.id === this.props.activeId;
    const classNameHeadlineContainer = classnames({
      [styles.headlineContainer]: true,
      [styles.active]: isActiveItem,
      [styles.noIcon]: !Boolean(d.icon),
    });

    const linkTo = isActiveItem ? '#' : '#' + d.id;
    const icon = d.icon ? (
      <div className={styles.headlineImageContainer}>
        <img src={`/contentful/${d.icon}`} alt={d.iconAltText} />
      </div>
    ) : null;

    return (
      <Link
        to={linkTo}
        onClick={() => {
          safeGa('send', {
            hitType: 'event',
            eventCategory: window.location.pathname.slice(1),
            eventAction: 'accordion-click',
            eventLabel: d.headline,
          });
          this.scrollToActive(d.id);
        }}
      >
        <div className={classNameHeadlineContainer}>
          {icon}
          <h2 className={styles.headline}>{d.headline}</h2>
        </div>
      </Link>
    );
  }

  renderItems() {
    const { items, activeId, displayChapterLink } = this.props;

    return items.map((d, i) => {
      const isActiveItem = d.id === activeId;
      const transparentSpace = isActiveItem ? (
        <div className={styles.transparentSpace} />
      ) : null;
      return (
        <li
          ref={el => (this[d.id] = el)}
          key={d.id}
          className={styles.listItem}
          aria-expanded={!this.state.isFirstLoad && isActiveItem}
        >
          {this.renderHeadlineContainer(d)}
          {transparentSpace}
          <Collapse
            forceInitialAnimation={false}
            isOpened={!this.state.isFirstLoad && isActiveItem}
          >
            <AccordionContent
              displayChapterLink={displayChapterLink}
              chapterLink={d.chapterLink}
              contents={d.contents}
              isOpened={!this.state.isFirstLoad && isActiveItem}
            />
          </Collapse>
        </li>
      );
    });
  }
  render() {
    const className = classnames({
      [styles.accordion]: true,
    });
    return <ul className={className}>{this.renderItems()}</ul>;
  }
}

Accordion.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      contents: AccordionContent.propTypes.contents.isRequired,
      chapterLink: PropTypes.string.isRequired,
    })
  ),
  displayChapterLink: PropTypes.bool,
  activeId: PropTypes.string,
};
Accordion.defaultProps = {
  displayChapterLink: true,
};
export default Accordion;



// WEBPACK FOOTER //
// ./src/components/accordion/accordion.js